/* eslint-disable angular/constant-name */

angular.
module("dx.webapp.validation").
constant("DX_URL_ERROR",
	Object.freeze({
		NO_ERROR: 0,
		OTHER: 1,
		NO_SUCH_HOST: 2,
		REDIRECT_TIMEOUT: 3,
		INVALID_FORMAT: 4,
	})
);
